module.exports = __webpack_public_path__ + "img/cg_oldtown_qr.718e8c32.jpg";